function Error() {
  return (
    <div className="error">
    </div>)
};

export default Error;